import { useUBL } from '@common/log-manager';
import { AdBanner } from '@widgets/ad';
import { parseQueryString } from '@domains/pdp-common';

export const useProductCardTypeAdBannerUbl = () => {
  const ubl = useUBL();
  return {
    impression: (item: AdBanner) => {
      ubl({
        category: 'impression',
        navigation: 'product_detail',
        object_type: 'banner',
        object_section: 'bottom_ad_banner',
        object_id: item.creative_id,
        object_idx: item.banner_index,
        data: { server_log: item.log ? parseQueryString(item.log) : undefined },
      });
    },
    click: (item: AdBanner, object_index?: number) => {
      ubl({
        category: 'click',
        navigation: 'product_detail',
        object_type: 'banner',
        object_section: 'bottom_ad_banner',
        object_id: item.creative_id,
        object_idx: item.banner_index,
        data: { server_log: item.log ? parseQueryString(item.log) : undefined },
      });
    },
  };
};
